<script>

import {createHelpers} from "vuex-map-fields";
import _ from "lodash";

const {mapFields} = createHelpers({
  getterType: 'achievement/getPayloadAchievement',
  mutationType: 'achievement/updatePayloadAchievement',
});

export default {
  name: "TheAchievementKindSelect",

  data() {
    return {
      dialog: false,
      selectedItem: null,
    };
  },

  watch: {
    prtf_achievement_kind_id: function (newValue, oldVal) {
      if (!_.isNil(oldVal)){
        this.prtf_achievement_unit_id = null;
        this.prtf_achievement_subunit_id = null;
      }
    },

  },

  props: {
    achievementKindsList: Array,
  },

  computed: {
    ...mapFields([
      'prtf_achievement_kind_id',
      'prtf_achievement_subunit_id',
      'prtf_achievement_unit_id',
    ]),

  },

  methods: {

  },


}
</script>

<template>
  <div>
    <v-autocomplete
      v-model="prtf_achievement_kind_id"
      :items="achievementKindsList"
      :color="$store.state.achievement.side_color"
      clearable
      item-text="name"
      item-value="id"
      outlined
      class="rounded-xl"
      label="Вид достижения*"
      no-data-text="Виды достижений отсутсвуют"
      dense
    >
      <template #item="data">
          <v-list-item-content>
            <v-list-item-title>{{data.item.name}}</v-list-item-title>
            <v-list-item-subtitle>{{data.item.description}}</v-list-item-subtitle>
          </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<style scoped>

</style>